<template>
  <span>
    <div style="text-align: center;">{{ errorMsgAccess }}</div>
    <router-view />
  </span>
</template>

<script>
//import Home from "@/components/Home";
import TrafficLayout from "@/layouts/TrafficLayout";

export default {
  components: {
    // Home
  },
  data: () => ({
    errorMsgAccess: null
  }),

/*  beforeRouteEnter(to, from, next) {
    if (to.query.redirectFrom) {
      next(vm => {
        // console.log(
        // "Sorry, you don't have the right access to reach the route requested"
        // );
        vm.errorMsgAccess =
          "Sorry, you don't have the right access to reach the route requested";
      });
    } else {
      next();
    }
  }, */
  created() {
    this.$emit("update:layout", TrafficLayout);
  }
};
</script>
